import { FC } from 'react';

import { RouteComponentProps, Route, Redirect } from 'react-router-dom';

import { useAuth } from '~/hooks/auth';

interface RouteProps {
  component: FC<RouteComponentProps>;
  path?: string;
  exact?: boolean;
  requiredRoles?: string[];
}

const AuthRoute: FC<RouteProps> = ({
  component: Component,
  path,
  exact = false,
  requiredRoles,
}): JSX.Element => {
  const { user } = useAuth();

  const isAuthenticated = !!user;

  const userHasRequiredRole = user?.role
    ? requiredRoles?.includes(user?.role)
    : false;

  // console.log('isAuthenticated', isAuthenticated);
  // console.log('userHasRequiredRole', userHasRequiredRole);

  const message = userHasRequiredRole
    ? 'Please log in to view this page'
    : "You can't be here!";

  return (
    <Route
      exact={exact}
      path={path}
      // render={(props: RouteComponentProps) => <Component {...props} />}
      render={(props: RouteComponentProps) =>
        !isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: userHasRequiredRole ? '/' : '/unauthorized',
              state: {
                message,
                requestPath: path,
              },
            }}
          />
        )
      }
    />
  );
};

export default AuthRoute;
